module.exports = __webpack_public_path__ + "static/media/icon_buscar_produto_catalogo.fa4a98ee.svg";